import SwiperCore, { Autoplay, Navigation } from 'swiper/core';

export function initHomepageSlider(gamesWrapperAttr, sliderEl) {
  let gamesWrapper = sliderEl || document.querySelector('.games[data-games="' + gamesWrapperAttr + '"]');

  if (gamesWrapper?.swiper) return;

  let gamesPerView = gamesWrapper.getAttribute('data-per-view');
  gamesPerView = !gamesPerView || isNaN(gamesPerView) ? 6 : parseInt(gamesPerView);
  const gamesSlider = new SwiperCore(gamesWrapper, {
    slidesPerView: gamesPerView,
    spaceBetween: 10,
    speed: 300,
    watchSlidesVisibility: true
    /*on: {
      slideChange: () => {
        window.dispatchEvent(new Event("resize"));
      },
    },*/
  });
  let nextBtn = gamesWrapper.querySelector('.btn-next');
  let previousBtn = gamesWrapper.querySelector('.btn-previous');
  nextBtn.addEventListener('click', () => {
    gamesSlider.slideTo(gamesSlider.activeIndex + gamesPerView, 300);
  });
  previousBtn.addEventListener('click', () => {
    gamesSlider.slideTo(gamesSlider.activeIndex - gamesPerView, 300);
  });
  gamesWrapper.swiper = gamesSlider;
  //initHomepageSliderButtons(homepageSliders[i]);
  //initGrabSlider(gamesList[i].querySelector('.games-body'));
}

export function initPanelSlider(wrapperAttr, slidesPerView, isAutoScroll) {
  if (!_CMS_MOBILE) {
    let wrapper = document.querySelector(wrapperAttr);
    if (!isAutoScroll) {
      SwiperCore.use([Navigation]);
      new SwiperCore(wrapper, {
        slidesPerView: slidesPerView,
        spaceBetween: 10,
        speed: 300,
        navigation: {
          nextEl: '.btn-next',
          prevEl: '.btn-previous'
        },
        watchSlidesVisibility: true
        /*on: {
          slideChange: () => {
            window.dispatchEvent(new Event("resize"));
          },
        },*/
      });
    } else {
      SwiperCore.use([Navigation, Autoplay]);
      new SwiperCore(wrapper, {
        loop: true,
        slidesPerView: slidesPerView,
        spaceBetween: 10,
        speed: 300,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.btn-next',
          prevEl: '.btn-previous'
        },
        watchSlidesVisibility: true
        /*on: {
          slideChange: () => {
            window.dispatchEvent(new Event("resize"));
          },
        },*/
      });
    }
  }
}
